import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    select: {
      minWidth: '20rem',
    },
    menuItem: {
      width: '100%'
    },
  }),
);

export const useOutlinedInputStyles = makeStyles((theme: Theme) => ({
  root: {
    fontFamily: 'fs-elliot-pro-bold',
    borderRadius: '2px',
    backgroundColor: theme.palette.primary.contrastText,
    '& .MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${theme.palette.secondary.dark}`,
    },
    '& .MuiOutlinedInput-root': {
      border: `2px solid ${theme.palette.light[100]}`,
      borderColor: theme.palette.light[100],
      maxWidth: 120,
    },
    '&:hover $notchedOutline': {
      borderColor: theme.palette.common.black,
    },
    '&$focused $notchedOutline': {
      border: `2px solid ${theme.palette.common.black}`,
    },
  },
  focused: {},
  notchedOutline: {},
}), { index: 1 });
